import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { timeAgo } from "@/lib/format";

const CFG = {
  healthy: { color: "#22C55E", label: "HEALTHY" },
  delayed: { color: "#EAB308", label: "DELAYED" },
  stale: { color: "#EAB308", label: "STALE" },
  "parse-error": { color: "#EF4444", label: "PARSE ERROR" },
  "no-data": { color: "#71717A", label: "NO DATA" },
};

function Dot({ health }) {
  const c = CFG[health] || CFG["no-data"];
  return (
    <span className="inline-flex items-center gap-2">
      <span className="relative flex h-2 w-2">
        {health === "healthy" && (
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-60" style={{ background: c.color }} />
        )}
        <span className="relative inline-flex rounded-full h-2 w-2" style={{ background: c.color }} />
      </span>
      <span className="font-mono text-xs" style={{ color: c.color }}>{c.label}</span>
    </span>
  );
}

export default function IngestStatusBanner() {
  const { data } = useQuery({
    queryKey: ["ingest-status"],
    queryFn: async () => (await api.get("/ingest-status")).data,
    refetchInterval: 15000,
  });

  const m = data?.metrics || {};
  const l = data?.logs || {};

  return (
    <div className="border-b border-border bg-card/60 px-4 lg:px-6 py-2.5 flex flex-wrap items-center gap-x-8 gap-y-2" data-testid="ingest-status-banner">
      <div className="flex items-center gap-3">
        <span className="overline">metrics ingest</span>
        <Dot health={m.health} />
        <span className="font-mono text-xs text-muted-foreground">{timeAgo(m.last_received_at)}</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="overline">logs ingest</span>
        <Dot health={l.health} />
        <span className="font-mono text-xs text-muted-foreground">{timeAgo(l.last_received_at)}</span>
      </div>
      <div className="flex items-center gap-3 ml-auto">
        <span className="font-mono text-xs text-muted-foreground" data-testid="raw-counts">
          raw: {data?.raw_metrics_count ?? 0} metrics · {data?.raw_logs_count ?? 0} logs · TTL {data?.retention_days ?? "—"}d
        </span>
      </div>
    </div>
  );
}
